module.exports = __webpack_public_path__ + "static/media/andrew-neel-1-29wyvvLJA-unsplash.05342aca.jpg";